<p-dialog [(visible)]="showTimeoutWarning" [modal]="true" [minY]="50" [baseZIndex]="10000" [draggable]="false"
  [closable]="false">
  <h1 class="tac">Session Timeout Warning</h1>
  <p class="tac">You will be <strong>logged out</strong> in {{(countMinutes !== 0 ? + countMinutes+'
    minute'+(countMinutes > 1 ? 's ' : ' ') : '') + countSeconds+' seconds'}}</p>
  <p-progressBar [value]="progressCount"></p-progressBar><br>
  <div class="p-grid">
    <div class="p-col-6">
      <button type="button" pButton (click)="showTimeoutWarning=false" label="Logout" class="p-button-danger"
        (click)="logout()"></button>
    </div>
    <div class="p-col-6">
      <button type="button" pButton (click)="showTimeoutWarning=false" label="Continue" class="p-button-primary"
        (click)="continue()"></button>
    </div>
  </div>
</p-dialog>
